import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { MetricOption } from '../../interfaces/MetricsInterface';

interface ChatMetricPillsProps {
  metrics: MetricOption[];
  onSelect: (metricValue: string) => void;
}

const ChatMetricPills = ({ metrics, onSelect }: ChatMetricPillsProps) => (
  <div className="chat-metric-pills" data-chat-copy-exclude>
    <span className="chat-metric-pills-label">Metrics used:</span>
    {metrics.map((metric) => (
      <button key={metric.value} type="button" className="chat-metric-pill" onClick={() => onSelect(metric.value)}>
        <span>{metric.label}</span>
        <ChevronRightIcon fontSize="small" />
      </button>
    ))}
  </div>
);

export default ChatMetricPills;
